export default __webpack_public_path__ + "static/1052-736a69f2633f9816e37059463f52c1e7.gif";